<div class="inputTitle" *ngIf="label">
    <span>{{ label }}</span>
</div>

<div [class.has-errors]="errors?.length" class="multifield" [hidden]="!isEditable">
    <button mat-icon-button class="downCheveron" [matMenuTriggerFor]="field"><i
            class="flaticon-down-chevron"></i></button>
    <mat-menu #field="matMenu">
        <button mat-menu-item (click)="setSelectField('price')">Amount</button>
        <button mat-menu-item (click)="setSelectField('percent')">Percentage</button>
    </mat-menu>

    <logzy-money-field *ngIf="selectField=='price'" [isEditable]="isEditable" [amount]="amount"
        (amountChange)="setAmount($event)" [currencyCode]="currencyCode" (currencyCodeChange)="setCurrency($event)"
        [placeholder]="placeholder" [minValue]="0" [maxlength]="10" class="w-100i">
    </logzy-money-field>
    <app-percent-field *ngIf="selectField=='percent'" [isEditable]="isEditable" [ngModel]="percent"
        (ngModelChange)="setPercentage($event)" [placeholder]="placeholder" fxLayout="column" class="w-100i">
    </app-percent-field>
</div>

<!-- <div class="viewLable" [hidden]="isEditable">
  <span>
      {{ getDisplay() }}
  </span>
</div> -->

<ul *ngIf="errors?.length" class="errorList">
    <li *ngFor="let item of errors" class="error">{{ item }}</li>
</ul>